import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

import { SnChannel } from '../../models';

@Component({
  templateUrl: './chat-export-time.component.html',
  styleUrls: ['./chat-export-time.component.scss'],
})
export class ChatExportTimeComponent implements OnInit {
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'startDatetime',
      type: 'datetimepicker',
      templateOptions: {
        required: true,
        label: t('common.startDate'),
        appearance: 'fill',
        minDate: () => this.channel.createdTimestamp,
        maxDate: () => this.formModel.endDatetime || new Date(),
      },
    },
    {
      key: 'endDatetime',
      type: 'datetimepicker',
      templateOptions: {
        required: true,
        label: t('common.endDate'),
        appearance: 'fill',
        minDate: () => this.formModel.startDatetime || this.channel.createdTimestamp,
        maxDate: () => new Date(),
      },
    },
  ];

  constructor(
    private readonly _dialogRef: MatDialogRef<ChatExportTimeComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly channel: SnChannel,
  ) {}

  public ngOnInit(): void {
    if (this.channel) {
      this._patchForm();
    }
  }

  public submit(): void {
    this._dialogRef.close(this.formModel);
  }

  private _patchForm(): void {
    this.formModel.startDatetime = this.channel.createdTimestamp;
    this.formModel.endDatetime = new Date();
  }
}
